import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    testid: "testimonial-card-1",
    quote:
      "John's coaching gave me a structure I could actually stick to. Within a month I had my mornings back, my focus back, and a plan I believed in for the first time in years.",
    author: "Mark S.",
    role: "Small Business Owner",
    img: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    testid: "testimonial-card-2",
    quote:
      "I was skeptical about NuCalm, but John walked me through it. Twenty minutes in the afternoon and my sleep at night completely changed. I feel like a different person.",
    author: "Elena R.",
    role: "Healthcare Executive",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    testid: "testimonial-card-3",
    quote:
      "When a contract dispute came up with our landlord, having a law firm one call away — without a scary hourly bill — was worth every penny. John made it simple to get set up.",
    author: "David T.",
    role: "Homeowner & Father of Two",
    img: "https://randomuser.me/api/portraits/men/85.jpg",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <h2
            data-testid="testimonials-heading"
            className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl"
          >
            What People Are Saying
          </h2>
          <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
            Real stories of energy regained, clarity achieved, and peace of mind secured.
          </p>
        </div>

        <div className="mt-12 grid gap-8 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.testid}
              data-testid={t.testid}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="relative flex flex-col rounded-3xl border border-slate-200 bg-[#FBF9F4] p-7 transition-all duration-200 hover:-translate-y-1 hover:shadow-lg hover:shadow-blue-900/5"
            >
              <Quote className="h-7 w-7 text-blue-200" />
              <div className="mt-3 flex gap-1" aria-label="5 out of 5 stars">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-slate-700">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-200 pt-4">
                <img
                  src={t.img}
                  alt={t.author}
                  className="h-10 w-10 rounded-full object-cover ring-2 ring-blue-100"
                  loading="lazy"
                />
                <div>
                  <p className="font-display text-sm font-bold text-slate-900">{t.author}</p>
                  <p className="text-xs text-slate-500">{t.role}</p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
